<template>
  <div>
    <b-container class="pt-2" fluid="md">
      <b-row class="text-left">
        <div class="col-lg-4">
          <b-card no-body>
            <b-tabs card fill>
              <b-tab title="NẠP THẺ" active>
                <topup-card-form :website="website"></topup-card-form>
              </b-tab>
              <b-tab title="TOP NẠP TIỀN">
                <b-card-text>
                  <b-list-group>
                    <b-list-group-item
                      class="d-flex align-items-center"
                      v-for="(top, index) in topRecharges"
                      :key="index"
                    >
                      <b-badge pill variant="danger" class="mr-3">{{
                        index + 1
                      }}</b-badge>
                      <span class="mr-auto"> {{ limit(top.name) }}</span>
                      <b-badge pill variant="warning"
                        >{{ Helper.formatMoney(top.total) }} đ
                      </b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <div class="col-lg-8">
          <div v-if="website.slide_banners">
            <b-carousel
              class="carousel-inner"
              :interval="4000"
              img-width="100%"
              img-height="300"
              controls
            >
              <b-carousel-slide v-for="(img, index) in website.slide_banners" :key="index">
                <template #img>
                  <b-img :src="img.value"></b-img>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
          <div class="carousel-inner" v-else>
            <b-img :src="website.image_slide"></b-img>
          </div>
        </div>
      </b-row>
    </b-container>
    <!-- END SECTION BANNER -->
    <!-- END MAIN CONTENT -->
    <auction v-if="auctions && enableFeature" :auctions="auctions" />
    <div class="main_content pt-5" v-if="sections.length <= 0">
      <!-- START SECTION SHOP -->
      <div
        v-for="category in categories"
        :id="category.slug"
        :key="category.slug"
        class="pt-5"
      >
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="heading_s3 text-center">
                <h2 class="category-title">Game {{ category.name }}</h2>
              </div>
              <div class="small_divider clearfix"></div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="account_package in category.packages"
              :key="account_package.slug"
            >
              <div class="product_box text-center">
                <div class="product_img">
                  <a
                    :href="
                      route('fe.package', {
                        domain: website.domain,
                        package: account_package.slug,
                      })
                    "
                  >
                    <img
                      :src="account_package.thumbnail"
                      :alt="account_package.name"
                    />
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li>
                        <a
                          :href="
                            route('fe.package', {
                              domain: website.domain,
                              package: account_package.slug,
                            })
                          "
                          ><i class="icon-heart"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a
                      :href="
                        route('fe.package', {
                          domain: website.domain,
                          package: account_package.slug,
                        })
                      "
                      >{{ account_package.name }}</a
                    >
                  </h6>
                  <div class="product_price">
                    <span class="price"
                      >Đã bán:
                      {{
                        Helper.formatMoney(
                          account_package.sold_account_count +
                            account_package.created_day_count * 85
                        )
                      }}</span
                    >
                  </div>
                  <div class="rating_wrap">
                    <div class="rating pb-2">
                      <div class="product_rate" style="width: 70%"></div>
                    </div>

                    <a
                      :href="
                        route('fe.package', {
                          domain: website.domain,
                          package: account_package.slug,
                        })
                      "
                      class="btn btn-fill-out btn-radius"
                      >Xem ngay</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="wheel in category.wheels"
              :key="wheel.slug"
            >
              <div class="product_box text-center">
                <div class="product_img">
                  <a
                    :href="
                      route('fe.wheel', {
                        domain: website.domain,
                        wheel: wheel.slug,
                      })
                    "
                  >
                    <img :src="wheel.thumbnail" :alt="wheel.name" />
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li>
                        <a
                          :href="
                            route('fe.wheel', {
                              domain: website.domain,
                              wheel: wheel.slug,
                            })
                          "
                          ><i class="icon-heart"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a
                      :href="
                        route('fe.wheel', {
                          domain: website.domain,
                          wheel: wheel.slug,
                        })
                      "
                      >{{ wheel.name }}</a
                    >
                  </h6>
                  <div class="product_price">
                    <span class="regular_price">
                      {{
                        Helper.formatMoney(
                          parseFloat(wheel.regular_price.toString())
                        )
                      }}
                      <span v-if="wheel.is_promo"> coin</span>
                      <span v-else> đ</span>
                    </span>
                    <span class="price">
                      {{
                        Helper.formatMoney(parseFloat(wheel.price.toString()))
                      }}
                      <span v-if="wheel.is_promo"> coin</span>
                      <span v-else> đ</span>
                    </span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating pb-2">
                      <div class="product_rate" style="width: 80%"></div>
                    </div>

                    <a
                      :href="
                        route('fe.wheel', {
                          domain: website.domain,
                          wheel: wheel.slug,
                        })
                      "
                      class="btn btn-fill-out btn-radius"
                      >Chơi ngay</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="random in category.random_prices"
              :key="random.slug"
            >
              <div class="product_box text-center">
                <div class="product_img">
                  <a @click="handleConfirm(random)">
                    <img :src="random.thumbnail" :alt="random.title" />
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li>
                        <a
                          :href="
                            route('fe.view_random_price', {
                              domain: website.domain,
                              random: random.slug,
                            })
                          "
                          ><i class="icon-heart"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a @click="handleConfirm(random)">{{ random.title }}</a>
                  </h6>
                  <div class="product_price">
                    <span class="regular_price"
                      >{{
                        Helper.formatMoney(random.regular_price)
                      }}đ/Lượt</span
                    >
                    <span class="price"
                      >{{ Helper.formatMoney(random.price) }}đ/Lượt</span
                    >
                  </div>
                  <div class="rating_wrap">
                    <div class="rating pb-2">
                      <div class="product_rate" style="width: 80%"></div>
                    </div>

                    <a
                      :href="
                        route('fe.view_random_price', {
                          domain: website.domain,
                          random: random.slug,
                        })
                      "
                      class="btn btn-fill-out btn-radius"
                      >Chơi Ngay</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="lucky_box in category.lucky_boxs"
              :key="lucky_box.slug"
            >
              <div class="product_box text-center">
                <div class="product_img">
                  <a
                    :href="
                      route('fe.luckyBox.detail', {
                        domain: website.domain,
                        slug: lucky_box.slug,
                      })
                    "
                  >
                    <img :src="lucky_box.thumbnail" :alt="lucky_box.name" />
                  </a>
                  <div class="product_action_box">
                    <ul class="list_none pr_action_btn">
                      <li>
                        <a
                          :href="
                            route('fe.luckyBox.detail', {
                              domain: website.domain,
                              slug: lucky_box.slug,
                            })
                          "
                          ><i class="icon-heart"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="product_info">
                  <h6 class="product_title">
                    <a
                      :href="
                        route('fe.luckyBox.detail', {
                          domain: website.domain,
                          slug: lucky_box.slug,
                        })
                      "
                      >{{ lucky_box.name }}
                    </a>
                  </h6>
                  <div class="product_price">
                    <span class="regular_price">
                      {{
                        Helper.formatMoney(
                          parseFloat(lucky_box.regular_price.toString())
                        )
                      }}
                      <span v-if="lucky_box.is_promo"> coin</span>
                      <span v-else> đ</span>
                    </span>
                    <span class="price">
                      {{
                        Helper.formatMoney(
                          parseFloat(lucky_box.price.toString())
                        )
                      }}
                      <span v-if="lucky_box.is_promo"> coin</span>
                      <span v-else> đ</span>
                    </span>
                  </div>
                  <div class="rating_wrap">
                    <div class="rating pb-2">
                      <div class="product_rate" style="width: 87%"></div>
                    </div>
                    <a
                      :href="
                        route('fe.luckyBox.detail', {
                          domain: website.domain,
                          slug: lucky_box.slug,
                        })
                      "
                      class="btn btn-fill-out btn-radius"
                    >
                      Chơi Ngay</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <service-list
        v-if="services.length > 0"
        :services="services.service"
        :user="user"
        :website="website"
      >
      </service-list>
    </div>
    <!-- END SECTION SHOP -->
    <div v-else class="main_content pt-5" id="home-page-builder">
      <div
        v-for="section in sections"
        :id="`section-${section.id}`"
        :key="`section-${section.id}`"
        class="pt-5"
      >
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div
                style="
                  margin-bottom: 5px;
                  padding-bottom: 5px;
                  position: relative;
                "
                class="heading_s2 text-center"
              >
                <h2>{{ section.title }}</h2>
                <hr
                  class="color-main"
                  style="
                    background-color: #e84118;
                    color: #fff;
                    width: 10%;
                    height: 2px;
                  "
                />
              </div>
            </div>
          </div>
          <div class="row justify-content-left p-4">
            <component-item
              v-for="component in section.components"
              :component="component"
              :key="`component-${component.id}`"
            />
          </div>
        </div>
      </div>
      <service-list
        v-if="services.length > 0"
        :services="services.service"
        :user="user"
        :website="website"
      >
      </service-list>
    </div>
  </div>
</template>

<script>
import TopupCardForm from "./TopupCardForm";
import ComponentItem from "./ComponentItem";
import Auction from "./Auction";
import dayjs from "dayjs";
import Cookie from "js-cookie";

export default {
  components: { Auction, TopupCardForm, ComponentItem },
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      },
    },
    auctions: {},
    categories: {
      Type: Object,
      default() {
        return {};
      },
    },
    category: {
      Type: Object,
      default() {
        return {};
      },
    },
    website: {
      Type: Object,
      default() {
        return {};
      },
    },
    enableFeature: {
      Type: Boolean,
      default() {
        return false;
      },
    },
    sections: {
      Type: Object,
      default() {
        return {};
      },
    },
    services: {
      Type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      topRecharges: {},
    };
  },
  created() {
    this.getTopRecharge();
    const isClose = Cookie.get("hidden_popup");
    if (this.website.notify_status === "on" && !isClose) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Thông báo",
          html: this.website.notification,
          showCancelButton: "Đóng",
          confirmButtonText: "Tắt trong 1h",
        })
        .then((result) => {
          if (result.isConfirmed) {
            Cookie.set("hidden_popup", 1, {
              expires: dayjs().add(1, "h").toDate(),
            });
          } else {
            console.log("Close");
          }
        });
    }
  },
  methods: {
    formatMoney(money) {
      return this.Helper.formatNumber(money);
    },
    async getTopRecharge() {
      try {
        const uri = this.route("fe_top_recharge", {
          domain: this.website.domain,
        });
        const response = await this.Request.get(uri);
        this.topRecharges = response.data;
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: "error",
          title: "Error",
          confirmButtonText: "Tắt trong 1h",
          text: this._.isEmpty(errorMessages)
            ? e.response.data.error
            : errorMessages[0],
        });
      }
    },
    async handleBuyRandomAccount(price) {
      try {
        const uri = this.route("fe_buy_random", {
          domain: this.website.domain,
        });
        const response = await this.Request.post(uri, { price: price.id });
        console.log(response);
        if (response.data.status === false) {
          await this.$swal.fire({
            title: "Có lỗi xảy ra!",
            text: response.data.message,
            icon: "error",
          });
        } else {
          await this.$swal.fire({
            icon: "success",
            title: "Thành Công",
            html: response.data.message,
          });
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: "error",
          title: "Error",
          text: this._.isEmpty(errorMessages)
            ? e.response.data.error
            : errorMessages[0],
        });
      }
    },
    async handleConfirm(price) {
      await this.$swal
        .fire({
          title: "Bạn có muốn thử vận may?",
          imageUrl: price.thumbnail,
          html: price.content,
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Thử ngay`,
          denyButtonText: `Huỷ`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.handleBuyRandomAccount(price);
          }
        });
    },

    limit(string = '', limit = 5) {
      if (string.length > 5) {
        return string.substring(0, limit) + "****"
      }
      return string;
    },
  },
};
</script>
